import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

const styles = (theme) => {
    return {
        button: {
            position: 'relative',
            width: 32,
            height: 32,
            padding: 0,
            borderColor: theme.palette.primary.mainBorder,
            borderWidth: 1,
            borderStyle: 'solid',
            cursor: 'pointer',
            backgroundColor: theme.palette.primary.main,
            '&$disabled': {
                cursor: 'default',
            },
            '&:hover:not($disabled)': {
                backgroundColor: theme.palette.primary.light,
            },
        },
        icon: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 24,
            height: 24,
            margin: 'auto',
            color: theme.palette.primary.displayText,
            '&$disabled': {
                color: theme.palette.primary.disabledDisplayText,
            },
        },
        default: {},
        disabled: {},
    };
}

class ControlButton extends Component {
    render = () => {
        const {classes} = this.props;

        const buttonClassName = classNames(
            classes.button,
            (this.props.disabled) ? classes.disabled : classes.default,
            this.props.className
        );

        const iconClassName = classNames(
            classes.icon,
            (this.props.disabled) ? classes.disabled : classes.default,
        );

        const tooltipProps = {
            title: (this.props.disabled || !this.props.tooltip) ? '' : this.props.tooltip,
            placement: (!this.props.tooltipPlacement) ? 'bottom' : this.props.tooltipPlacement,
        };

        return (
            <Tooltip
                {...tooltipProps}
                id='tooltip-control-button'
                enterDelay={500}
            >
                <Paper
                    className={buttonClassName}
                    square={this.props.square}
                    elevation={this.props.elevation}
                    onClick={this._handleClick}
                    onMouseOut={this._handleMouseOut}
                    onMouseOver={this._handleMouseOver}
                >
                    {React.cloneElement(this.props.children, {className: iconClassName})}
                </Paper>
            </Tooltip>
        );
    }

    _handleClick = (e) => {
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(e);
        }
    }
}

ControlButton.propTypes = {
    square: PropTypes.bool,
    elevation: PropTypes.number,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipPlacement: PropTypes.string,
    onClick: PropTypes.func,
}

export default withStyles(styles)(ControlButton);
